export const itemLinks = item => item?.inventory_match_items ?? item?.inventory_document_items ?? [];

// The API can cap page sizes; follow total counts, not the requested page size.
export async function fetchAllMatchItems(get, url) {
  const result = [];
  const seen = new Set();
  for (let page = 1; ; page++) {
    const response = await get(url + '&sort=id&direction=asc&item_per_page=200&page=' + page);
    const data = response.data.data;
    const rows = data.items || [];
    const total = Number(data.total_item_count);
    if (!rows.length) {
      if (Number.isFinite(total) && result.length < total) throw new Error('Incomplete item pagination');
      return result;
    }
    for (const row of rows) {
      if (seen.has(row.id)) throw new Error('Repeated item in pagination');
      seen.add(row.id);
      result.push(row);
    }
    if (Number.isFinite(total) && result.length >= total) return result;
  }
}

export function matchEdges(requests) {
  return requests.flatMap(receipt => itemLinks(receipt).map(link => ({
    key: receipt.id + ':' + link.id, receipt, link, left: String(link.id), right: String(receipt.id)
  })));
}

export const isFullyMatched = (quantity, matched) => Math.abs(Number(quantity || 0) - Number(matched || 0)) < 0.000001;

export function connectionPath(x1, y1, x2, y2, labelY) {
  const middle = (x1 + x2) / 2;
  const bend = (x2 - x1) / 4;
  return `M ${x1} ${y1} C ${x1 + bend} ${y1}, ${middle - bend} ${labelY}, ${middle} ${labelY} C ${middle + bend} ${labelY}, ${x2 - bend} ${y2}, ${x2} ${y2}`;
}
